export default __webpack_public_path__ + "static/media/1973childrensday.91c2237c.jpg";